
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'
import Toast from 'vux/src/components/toast/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Blur from 'vux/src/components/blur/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Divider from 'vux/src/components/divider/index.vue'
import Card from 'vux/src/components/card/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import CellFormPreview from 'vux/src/components/cell-form-preview/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Badge from 'vux/src/components/badge/index.vue'
import Loading from 'vux/src/components/loading/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import { parseTime } from '@/api/time'

export default {
components: {
Blur,
XHeader,
Card,
Divider,
Cell,
CellFormPreview,
CellBox,
Badge,
Group,
Loading,
XTextarea,
XInput,
XSwitch,
XButton,
Toast,
Swiper,
SwiperItem,
TransferDom
},
data () {
return {
order_time: require('../../assets/time.png'), //  时间图片
data: [],
minute: 0, // 分钟
second: 0 
}
},
created () {
const orderId = this.$route.query.order_id
this.$store.dispatch('getOrderGoodsInfo', orderId).then((res) => {
res.data.orderAmountPrice = this.roundValue(parseFloat(res.data.order_amount))
res.data.addTime = parseTime(res.data.add_time, '{y}-{m}-{d} {h}:{i} ')
res.data.order_goods.forEach((e) => {
e.orderGoodsPrice = this.roundValue(parseFloat(e.final_price))
})
console.log(res.data)
this.data = res.data
this.minute = res.data.diff_pay_time_
this.countDown()
})
},
methods: {
orderEdit (key) {
this.$router.push({path: '/order/order_edit', query: { order_id: key }})
},
countDown () {
this.second = this.minute * 60
let clock = window.setInterval(() => {
this.second--
this.minute = Math.floor(this.second / 60)
if (this.second <= 0) {
window.clearInterval(clock)
}
}, 1000)
},

roundValue (val) {
return Math.round(val * 100) / 100
}
}
}



// WEBPACK FOOTER //
// ./src/components/order/OrderInfo.vue